<template>
  <div
    id="transcription-button"
    class="transcribe-control new-feature"
    @click="clickTranscriptionButton"
  >
    <ClosedCaptioningRegular v-if="!transcribing" />
    <ClosedCaptioningSolid v-else class="transcribing" />
    <b-badge class="beta-badge" variant="danger">BETA</b-badge>
    <b-tooltip target="transcription-button" placement="bottom">Toggle transcription/translation</b-tooltip>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import ClosedCaptioningRegular from '@/components/icons/ClosedCaptioningRegular';
import ClosedCaptioningSolid from '@/components/icons/ClosedCaptioningSolid';

export default {
  name: "TranscriptionButton",
  components: {
    ClosedCaptioningRegular,
    ClosedCaptioningSolid,
  },
  computed: {
    ...mapGetters("transcription", ["transcribing"]),
    ...mapGetters("user", ["isMobile"]),
  },
  methods: {
    clickTranscriptionButton() {
      if (!this.transcribing) {
        this.$emit("startTranscription");  
      } else {
        this.$emit("stopTranscription");
      }
    }
  }
};
</script>

<style lang="scss">
.transcribe-control {
  display: inline-block;
  cursor: pointer;
  svg {
    width: 28px;
    fill: #b7f1e0;

    &.transcribing {
      fill: #28a745;
    }
  }

  &.new-feature {
    position: relative;

    .badge.beta-badge {
      position: absolute;
      top: -6px;
      right: calc(-60%);
      border-radius: 10px;
      font-size: 8px;
      padding: 3px 6px;
      @media screen and (max-width: 767px) {
        font-size: 8px;
        padding: 3px 6px;
        top: -4px;
        right: -5px;
      }
    }
  }
}
</style>